import adminRequest from "@/api/adminRequest";

export function getLicense() {
    return adminRequest({
        url: '/license',
        method: 'get'
    })
}

export function getLicenseModules() {
    return adminRequest({
        url: '/license/modules',
        method: 'get'
    })
}